<!--  -->
<template>
  <create-demand :isCreate="false" />
</template>

<script>
import CreateDemand from './createDemand.vue';
export default {
  data() {
    return {};
  },

  components: {
    CreateDemand,
  },

  computed: {},

  methods: {},
};
</script>
<style lang="scss" scoped></style>
